import type { PurchaseOrderRecordLine } from '@/data/purchaseOrderRecord';

/** Units still due on a line (never negative; cancelled lines have none). */
export function purchaseLineOpenQty(line: Pick<PurchaseOrderRecordLine, 'qty' | 'receivedQty' | 'status'>): number {
  if (line.status === 'cancelled') return 0;
  return Math.max(0, line.qty - line.receivedQty);
}

/** The name a line goes by: its catalog item, else its description. */
export function purchaseLineName(line: Pick<PurchaseOrderRecordLine, 'item' | 'description'>): string {
  return line.item?.name || line.description || 'Line';
}

/** "Inventory", "Event sale · 0917061". */
export function purchaseLineUseLabel(line: Pick<PurchaseOrderRecordLine, 'disposition' | 'event'>): string {
  if (line.disposition === 'event_sale') return line.event?.code ? `Event sale · ${line.event.code}` : 'Event sale';
  if (line.disposition === 'cross_rental') return 'Cross-rental';
  return 'Inventory';
}

/** "SM58-LC", "ULXD2B58-G50 · in: ULX-41120, ULX-41121". */
export function purchaseLineMeta(line: Pick<PurchaseOrderRecordLine, 'item' | 'serialsReceived'>): string {
  const shown = line.serialsReceived.slice(0, 4).join(', ');
  const more = line.serialsReceived.length > 4 ? ` +${line.serialsReceived.length - 4}` : '';
  const serials = line.serialsReceived.length ? `in: ${shown}${more}` : '';
  return [line.item?.code, serials].filter(Boolean).join(' · ');
}
